import axios from "axios";
import { type AttributeValue, type Attributes, flare } from "@flareapp/js";

type CustomContext = Record<string, AttributeValue>;

function toFlareAttributes(custom: CustomContext, extra: Attributes = {}): Attributes {
    const existing = (extra["context.custom"] ?? {}) as CustomContext;

    return {
        ...extra,
        "context.custom": { ...existing, ...custom },
    };
}

export function reportToFlare(error: unknown, custom: CustomContext = {}): void {
    if (!import.meta.env.VITE_FLARE_KEY) return;

    if (axios.isCancel(error)) return;

    if (axios.isAxiosError(error)) {
        const status = error.response?.status ?? 0;

        if (status >= 400 && status < 500) return;

        flare.reportSilently(
            error,
            toFlareAttributes({
                ...custom,
                http_status: status,
                http_method: error.config?.method?.toUpperCase() ?? "",
                http_url: error.config?.url ?? "",
            })
        );
        return;
    }

    if (error instanceof Error) {
        flare.reportSilently(error, toFlareAttributes(custom));
    }
}
